<template>
    <div id="contenedor-contrato-catalogo">
      <v-simple-table>
        <template
          v-slot:default>
          <thead>
            <tr>
              <template
                v-for="(header, index) in getHeaders">
                <template>
                  <th
                    :key="`header-${index}`"
                    class="secondary--text"
                    :class="['Importe', 'P. Unitario'].includes(header) ? 'text-center' : ''">
                    {{ header }}
                  </th>
                </template>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(concepto, index) in getCatalogoConceptos"
              :key="`concepto-${index}`"
              :class="colorPartida(concepto.nivel)">
              <td>
                <small class="caption">
                  {{ concepto.orden }}
                </small>
              </td>
              <td>
                <template
                  v-if="concepto.padre">
                  {{ concepto.padre.clave }}
                </template>
              </td>
              <td>
                {{ concepto.clave }}
              </td>
              <td
                v-if="!soloLectura">
                <template
                  v-if="concepto.favoritos.length <= 0">
                  <v-btn
                    v-if="concepto.tipo === 2"
                    @click="agregarConceptoFavorito(concepto)"
                    icon>
                    <v-icon>
                      mdi-star-outline
                    </v-icon>
                  </v-btn>
                </template>
                <template
                  v-else>
                  <v-btn
                    icon
                    @click="desmarcarComoFavorito(concepto)">
                    <v-icon
                      color="yellow">
                      mdi-star
                    </v-icon>
                  </v-btn>
                </template>
              </td>
              <td>
                {{ concepto.concepto }}
              </td>
              <td>
                {{ concepto.unidad }}
              </td>
              <td>
                <template
                  v-if="concepto.tipo > 1">
                  {{ concepto.cantidad }}
                </template>
              </td>
              <td
                align="right">
                <template
                  v-if="concepto.tipo > 1">
                  {{ concepto.precioUnitario | currency }}
                </template>
                <template v-if="concepto.tipo < 2">
                    {{ concepto.tipo === 0 ? 'Total Partida:' : 'Total SubPartida:' }}
                </template>
              </td>
              <td
                align="right">
                <template
                  v-if="concepto.tipo > 1">
                  <v-chip
                    color="grey lighten-2"
                    small>
                    {{ concepto.importe | currency }}
                  </v-chip>
                </template>
                <template
                  v-if="concepto.tipo < 2">
                  <v-chip
                    color="grey lighten-1"
                    small>
                    {{ concepto.tipo === 0
                    ? concepto.totalPartida
                    : concepto.totalPartida | currency }}
                  </v-chip>
                </template>
              </td>
              <td
                v-if="!soloLectura"
                width="200px"
                align="right">
                <v-tooltip
                  v-if="concepto.tipo < 2 && mixValidaScopesActions(1)"
                  top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      @click="agregarSubPartida(concepto)"
                      icon>
                      <v-icon>
                        mdi-plus-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar SubPartida</span>
                </v-tooltip>
                <v-tooltip
                v-if="concepto.tipo < 2 && mixValidaScopesActions(1)"
                top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      @click="agregarConcepto(concepto)"
                      icon>
                      <v-icon>
                        mdi-cash-multiple
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Concepto</span>
                </v-tooltip>
                <v-tooltip
                v-if="mixValidaScopesActions(2)"
                top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      @click="editar(concepto)"
                      icon>
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <!-- <v-btn
                      v-if="!concepto.tieneEstimaciones"
                      v-bind="attrs" v-on="on"
                      @click="editar(concepto)"
                      icon>
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn> -->
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip
                v-if="mixValidaScopesActions(3)"
                top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="!concepto.tieneEstimaciones"
                      v-bind="attrs" v-on="on"
                      @click="borrar(concepto)"
                      icon>
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-row justify="center" align="center" class="my-5">
        <v-btn
          @click="pagina++"
          rounded
          depressed
          v-if="catalogo.length > 20 && pagina < cantidadPaginas">
          Mostrar mas...
          <v-chip
            small
            disabled
            class="ml-1">
            {{ pagina }} / {{ cantidadPaginas }}
          </v-chip>
        </v-btn>
        <v-btn
          @click="pagina = cantidadPaginas"
          rounded
          depressed
          v-if="catalogo.length > 20 && pagina < cantidadPaginas">
          Mostrar todo
          <v-chip
            small
            disabled
            class="ml-1">
            {{ catalogo.length }}
          </v-chip>
        </v-btn>
      </v-row>
    </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoCatalogo',
  components: {
  },
  props: {
    catalogo: {
      type: Array,
      required: true,
    },
    mostrarAcciones: {
      type: Boolean,
      required: false,
      default: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      pagina: 1,
    };
  },
  methods: {
    colorPartida(tipo) {
      if (tipo === 1) return 'base4 font-weight-bold primary--text';
      if (tipo === 2) return 'amber darken-1 white--text';
      if (tipo === 3) return 'amber lighten-2';
      return '';
    },
    agregarSubPartida(concepto) {
      eventBus.$emit('agregar-sub-partida-catalogo', concepto);
    },
    agregarConcepto(concepto) {
      eventBus.$emit('agregar-catalogo-concepto', concepto);
    },
    agregarConceptoFavorito(concepto) {
      eventBus.$emit('agregar-catalogo-favorito', concepto);
    },
    desmarcarComoFavorito(concepto) {
      eventBus.$emit('remover-catalogo-favorito', concepto);
    },
    borrar(concepto) {
      eventBus.$emit('eliminar-catalogo-concepto', concepto);
    },
    editar(concepto) {
      eventBus.$emit('editar-catalogo-concepto', concepto);
    },
  },
  computed: {
    getCatalogoConceptos() {
      const catalogo = this.catalogo
        .slice()
        .sort((a, b) => a.orden - b.orden)
        .map((concepto) => {
          let nivel = 1;
          const tengoPadreSubNivel = this.catalogo
            .filter((c) => c.tipo === 1)
            .some((c) => concepto.idPadre === c.id);

          // Si nivel 2
          if (concepto.tipo === 1) {
            nivel = 2;
          }

          // Si es nivel 3
          if (concepto.tipo === 1 && tengoPadreSubNivel) {
            nivel = 3;
          }

          // Si es nivel 4 o concepto
          if (concepto.tipo === 2) {
            nivel = 4;
          }

          return {
            ...concepto,
            nivel,
          };
        })
        .map((concepto) => {
          const nuevoConcepto = concepto;
          // Concepto estimado
          nuevoConcepto.tieneEstimaciones = concepto.estimado.length > 0;
          // Checar si el concepto esta estimado
          if (nuevoConcepto.tieneEstimaciones) {
            nuevoConcepto.cantiadEstimada = this.$ObjSumar(concepto.estimado, 'cantidad');
            nuevoConcepto.importeEstimado = this.$ObjSumar(concepto.estimado, 'importe');
          }
          // Regresar el nuevo concepto
          return nuevoConcepto;
        })
        .map((concepto) => {
          let total = 0;
          if (concepto.tipo === 1) {
            const hijos = this.catalogo.filter(({ idPadre }) => idPadre === concepto.id);
            total = this.$ObjSumar(hijos, 'importe');
          }
          if (concepto.tipo === 2) {
            total = concepto.importe;
          }
          return {
            ...concepto,
            total,
          };
        });
      const catalogoConTotales = catalogo.map((concepto) => {
        let totalPartida = 0;
        if (concepto.tipo === 0) {
          // Nivel 1
          const hijos = catalogo
            .filter(({ idPadre }) => idPadre === concepto.id);
          totalPartida = this.$ObjSumar(hijos, 'total');
          hijos.forEach((hijoNivel1) => {
            // SubPartidas Nivel 2
            const hijosNivel2 = catalogo
              .filter(({ idPadre, tipo }) => idPadre === hijoNivel1.id && tipo === 1);
            totalPartida += this.$ObjSumar(hijosNivel2, 'total');
            hijosNivel2.forEach((hijoNivel2) => {
            // SubPartidas Nivel 3
              const hijosNivel3 = catalogo
                .filter(({ idPadre, tipo }) => idPadre === hijoNivel2.id && tipo === 1);
              totalPartida += this.$ObjSumar(hijosNivel3, 'total');
              hijosNivel3.forEach((hijoNivel3) => {
                // SubPartidas Nivel 4
                const hijosNivel4 = catalogo
                  .filter(({ idPadre, tipo }) => idPadre === hijoNivel3.id && tipo === 1);
                totalPartida += this.$ObjSumar(hijosNivel4, 'total');
                hijosNivel4.forEach((hijoNivel4) => {
                // SubPartidas Nivel 5
                  const hijosNivel5 = catalogo
                    .filter(({ idPadre, tipo }) => idPadre === hijoNivel4.id && tipo === 1);
                  totalPartida += this.$ObjSumar(hijosNivel5, 'total');
                });
              });
            });
          });
        }
        if (concepto.tipo === 1) {
          // Nivel 1
          const hijos = catalogo
            .filter(({ idPadre }) => idPadre === concepto.id);
          totalPartida = this.$ObjSumar(hijos, 'total');
          hijos.forEach((hijoNivel1) => {
            // SubPartidas Nivel 2
            const hijosNivel2 = catalogo
              .filter(({ idPadre, tipo }) => idPadre === hijoNivel1.id && tipo === 1);
            totalPartida += this.$ObjSumar(hijosNivel2, 'total');
            hijosNivel2.forEach((hijoNivel2) => {
            // SubPartidas Nivel 3
              const hijosNivel3 = catalogo
                .filter(({ idPadre, tipo }) => idPadre === hijoNivel2.id && tipo === 1);
              totalPartida += this.$ObjSumar(hijosNivel3, 'total');
              hijosNivel3.forEach((hijoNivel3) => {
                // SubPartidas Nivel 4
                const hijosNivel4 = catalogo
                  .filter(({ idPadre, tipo }) => idPadre === hijoNivel3.id && tipo === 1);
                totalPartida += this.$ObjSumar(hijosNivel4, 'total');
                hijosNivel4.forEach((hijoNivel4) => {
                // SubPartidas Nivel 5
                  const hijosNivel5 = catalogo
                    .filter(({ idPadre, tipo }) => idPadre === hijoNivel4.id && tipo === 1);
                  totalPartida += this.$ObjSumar(hijosNivel5, 'total');
                });
              });
            });
          });
        }
        return {
          ...concepto,
          totalPartida,
        };
      });

      return this.mixMostrarMas(catalogoConTotales, this.pagina, 20);
    },
    cantidadPaginas() {
      return Math.floor(this.catalogo.length / 20) + 1;
    },
    getHeaders() {
      if (!this.soloLectura) return ['Orden', 'Padre', 'Clave', '', 'Descripción', 'Unidad', 'Cantidad', 'P. Unitario', 'Importe', ''];
      return ['Orden', 'Padre', 'Clave', 'Descripción', 'Unidad', 'Cantidad', 'P. Unitario', 'Importe'];
    },
  },
};
</script>

<style lang="scss">

</style>
